import React, { Fragment, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { Loader } from "../../components/Loader/Loader";
import { formatDate } from "../../helpers/formatDate"
import { AppDispatch, RootState } from "../../store";
import { fetchPostById } from "../../store/slices/exactPostSlice";
import { Section, TitleH2 } from "../../styles/sharedStyles";
import { Created, Tag, Tags } from "../Blog/Post/styles";

import { Recommended } from "./Recommended"
import {
  Container,
  Content,
  Paragraph,
} from "./styles";

export const PostDetails = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch<AppDispatch>();

  const { post, status, error } = useSelector((state: RootState) => state.exactPost);

  useEffect(() => {
    if (id) {
      dispatch(fetchPostById(Number(id)));
    }
  }, [dispatch, id]);

  if (status === "loading" || !post) {
    return <Loader />;
  }

  if (status === "failed") {
    return <div>Ошибка: {error}</div>;
  }

  return (
    <Fragment>
      <Section>
        <Container>
          <Created>{formatDate(post.created_at)}</Created>
          <TitleH2>{post.title}</TitleH2>
          <Tags>
            {post.tags.map(tag => (
              <Tag key={tag.id}>{tag.name}</Tag>
            ))}
          </Tags>
          <Content>
            {post.content.split("\n").map((paragraph, index) => (
              <Paragraph key={index}>{paragraph}</Paragraph>
            ))}
          </Content>
        </Container>

      </Section>
      <Section>
        <TitleH2>Читайте также</TitleH2>
        <Recommended currentPostId={post.id} />
      </Section>
    </Fragment>
  );
};
